<template>
  <input type="text" class="input-mini" v-bind:value="value" v-on:input="$emit('input', $event.target.value)" />
</template>
<script>
export default {
  name: 'timepicker',
  props: ['value'],
  mounted: function () {
    // activate the plugin when the component is mounted.
    $(this.$el).mask('99:99');
    $(this.$el).timepicker({
      showPeriodLabels: false,
      minutes: {
        starts: 0,
        ends: 50,
        interval: 10,
      },
      showNowButton: true,
      showDeselectButton: true,
      showCloseButton: true,
      onClose: (time) => {
        this.onClose(time);
      },
    });
  },
  methods: {
    // callback for when the selector popup is closed.
    onClose(time) {
      if (time === '__:__') {
        time = null;
      }
      this.$emit('input', time); //maybe you need to validate something here? Dont knwo the plugin well enough.
    },
  },
};
</script>
